import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroGuarantees } from '../data/finanza';
import { REAL_MOCKUP as PRODUCT_IMAGE } from '../data/realImages';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-seyes" data-id="element-150" data-mp="4mrvd3yve5mt">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-[#FF8A7A] sm:left-8 lg:left-12" data-id="element-151" data-mp="1297cg4ndx19u" />

      <div className="relative mx-auto max-w-6xl px-6 pb-16 pt-4 sm:px-14 sm:pb-20 sm:pt-6 lg:pb-28" data-id="element-152" data-mp="xbfkjamqpf5n">
        

        <div className="mt-4 flex flex-col sm:mt-12 lg:mt-16 lg:grid lg:grid-cols-[1.15fr_0.85fr] lg:items-center lg:gap-12" data-id="element-153" data-mp="s9zx5bx3awk3">
          <div className="contents lg:block" data-id="element-154" data-mp="neauv0tor1k3">
            <motion.h1 initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            ease: EASE
          }} className="order-1 text-balance text-center font-serif text-[clamp(1.6rem,8vw,2.15rem)] leading-[1.05] [hyphens:none] sm:leading-[0.95] lg:text-left tracking-tight text-[#1E2B58] sm:text-6xl lg:text-[4rem]" data-id="element-155" data-mp="3d1scj2wkntvr">
              Entra in aula con l'educazione{' '}
              <span className="relative inline-block whitespace-nowrap" data-id="element-156" data-mp="3e8wjkowjcyld">
                <motion.span aria-hidden="true" initial={{
                scaleX: 0
              }} animate={{
                scaleX: 1
              }} transition={{
                duration: 0.3,
                delay: 0.25,
                ease: EASE
              }} className="absolute inset-x-[-0.08em] bottom-[0.08em] top-[0.38em] -z-0 origin-left -rotate-1 rounded-[0.12em] bg-[#F2B134]/80" data-id="element-157" data-mp="3eb8xmqz6aot5" />
                <span className="relative" data-id="element-158" data-mp="2hj5ddsevtmzq">finanziaria</span>
              </span>{' '}
              già{' '}
              <span className="relative inline-block whitespace-nowrap italic text-[#1F9D6B]" data-id="element-159" data-mp="2lkike5tpnw88">
                pronta
                <svg aria-hidden="true" viewBox="0 0 200 14" preserveAspectRatio="none" className="absolute -bottom-1.5 left-0 h-3 w-full sm:-bottom-2.5" data-id="element-160" data-mp="s2b7hx6yyh4m">
                  <motion.path d="M3 9 C 45 3, 95 2, 135 6 S 185 11, 197 4" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" vectorEffect="non-scaling-stroke" initial={{
                  pathLength: 0
                }} animate={{
                  pathLength: 1
                }} transition={{
                  duration: 0.3,
                  delay: 0.35,
                  ease: EASE
                }} data-id="element-161" data-mp="n9i3xcn8leu4" />
                </svg>
              </span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: 0.08,
            ease: EASE
          }} className="order-3 mx-auto mt-4 max-w-xl text-center text-[15px] lg:mx-0 lg:text-left leading-snug text-[#1E2B58]/75 sm:mt-8 sm:text-xl sm:leading-relaxed" data-id="element-162" data-mp="114kj6qdz4gjl">
              Un anno di educazione finanziaria già pronto: 6 volumi per Primaria e Secondaria, in linea
              con le Linee guida 2024 – lezioni, schede, attività e giudizi inclusi.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: 0.16,
            ease: EASE
          }} className="order-4 mt-5 sm:mt-8 lg:mt-10" data-id="element-163" data-mp="2b0fynl9f4xeg">
              <div className="flex justify-center lg:justify-start" data-id="element-164" data-mp="2ozz3a430tqm0">
                <CtaButton href="#offer-card" className="w-full sm:w-auto" data-id="element-165" data-mp="2oynzi49ksiuw" />
              </div>
              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-1.5 text-xs text-[#1E2B58]/70 sm:mt-6 sm:gap-x-6 sm:text-sm lg:justify-start" data-id="element-166" data-mp="2txhbttd4m3th">
                {heroGuarantees.map(item => <li key={item} className="flex items-center gap-2" data-id="element-167" data-mp="zlsvbmr8xt6z">
                    <CheckIcon className="h-4 w-4 text-[#1F9D6B]" aria-hidden="true" data-id="element-168" data-mp="4aco3i0njza2" />
                    {item}
                  </li>)}
              </ul>
            </motion.div>
          </div>

          <motion.figure initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3,
          delay: 0.12,
          ease: EASE
        }} className="relative order-2 mx-auto mt-4 w-full max-w-md sm:mt-12 sm:pt-10 lg:mt-0" data-id="element-169" data-mp="e8im3ojc8l9n">
            <div aria-hidden="true" className="absolute right-0 top-0 z-10 hidden -rotate-3 items-end gap-1 sm:flex" data-id="element-170" data-mp="3ct0mbgmm4hgu">
              <svg viewBox="0 0 60 50" className="h-10 w-12 text-[#1F9D6B]" fill="none" data-id="element-171" data-mp="3rhwvjh0eo0j1">
                <path d="M56 6 C 40 4, 18 12, 10 40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-172" data-mp="3mnail9eodzwu" />
                <path d="M4 32 L10 42 L18 34" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-173" data-mp="2u0pnbxv2x3o0" />
              </svg>
              <span className="font-serif text-xl italic leading-tight text-[#1F9D6B]" data-id="element-174" data-mp="19hvokv7ep1bg">
                6 volumi
                <br data-id="element-175" data-mp="1eaos5fr523ly" />+ 5 bonus
              </span>
            </div>
            {PRODUCT_IMAGE && <img src={PRODUCT_IMAGE} alt="Il pacchetto FINANZA PRONTA: sei volumi di educazione finanziaria per la scuola con programmazione, lezioni, attività e valutazione" className="relative mx-auto h-60 w-auto drop-shadow-xl sm:h-auto sm:w-full" data-id="element-176" data-mp="zlsk3ip30qlc" />}
          </motion.figure>
        </div>
      </div>
    </section>;
}